module.exports = __webpack_public_path__ + "static/media/waze-icon.e5422317.svg";